export const rolesApp = {
  PRODUCTOR: 'Productor',
  RRPP: 'Rrpp',
  REDIMIDOR: 'Redimidor',
  DEFAULT: 'Default',
  ADMIN: 'Admin',
  SUPERADMIN: 'SuperAdmin',
  POS: 'POS'
};
